(function ($) {
    var currentDiscoverPage = 1;
    var discoverAjax = null;
    var ajaxTimeout = null;
    var filters = [];
    var template = $('#js-discover-item').html();
    var discoverCount = $('#discover-count');
    var filterDropdown = $('#any');

    var searchDiscover = function () {
        var $loader = $('.js-discover-loader');
        var $list = $('#js-discover-list');

        Mustache.parse(template);

        var data = {
            page: currentDiscoverPage,
            nonce: rissb_var.nonces.get_discover,
        };

        data.filters = $('form').serialize();
        data.sort = $('input[name="sort[]"]').serialize();

        if (data.page == 1) {
            $loader.removeClass('d-none');
            $list.empty();
        }

        if (discoverAjax) {
            discoverAjax.abort();
        }

        discoverAjax = $.post('/api/discover', data, function (res) {
            var rendered = Mustache.render(template, res.data);

            $loader.addClass('d-none');

            // List rendering
            $list.html(rendered);

            $(rendered).imagesLoaded(function () {
                $.fn.matchHeight._apply('[data-mh="card-discover"]');
            });

            // Update count
            discoverCount.text(res.data.data.length);
        });
    };

    $(document).ready(function () {
        $('#discover-form').on('submit', function (evt) {
            evt.preventDefault();

            searchDiscover();
        });

        $('.js-filters').on('change', function (evt) {
            filterTextArray = [];
            filterDropdown.html('');

            var checked = $('.js-filters:checkbox:checked');

            if (checked.length > 0) {
                checked.each(function (index, value) {
                    switch (value.value) {
                        case 'conference':
                            filterTextArray.push('Conference Resources');
                            break;
                        case 'information':
                            filterTextArray.push('Helpful Resources');
                            break;
                        case 'news-central':
                            filterTextArray.push('News');
                            break;
                        case 'webinar':
                            filterTextArray.push('Webinars');
                            break;
                        default:
                            break;
                    }
                });

                filterDropdown.html(filterTextArray.join(", "));
            }
            else {
                filterDropdown.html('Any');
            }
        });
    });
})(jQuery);
